import React from "react";
import styled from "styled-components";

import Text from "./vox-web/components/Text";
import MediaPlayer from "./vox-web/components/MediaPlayer";

const Wrapper = styled.div`
  /* margin-bottom: 1rem; */
  ${props => props.notPublished && `border: 1px solid red;`};
  ${props => props.width && `width: ${props.width};`};
`;

const MediaItem = props => (
  <Wrapper width={props.width}>
    <MediaPlayer
      id={props.mediaAsset.id}
      mediaType={props.withCover && props.mediaAsset.mediaType !=="embed/audioboom" ? "video" : props.mediaAsset.mediaType}
      src={props.mediaAsset.mediaUri}
      cover={
        props.mediaAsset.mediaMetadata &&
        props.mediaAsset.mediaMetadata.thumbnailUrl
      }
      jwPlatformID={
        props.mediaAsset.mediaMetadata &&
        props.mediaAsset.mediaMetadata.jwplayerId
      }
    metadata={props.mediaAsset.mediaMetadata}
    />
    <Text bold size={1} spacing={0.5} clip={props.clipTitle}>
      <span style={{ color: `rgba(${props.color}, 1)` }}>
        {props.mediaAsset.mediaTitle}
      </span>
    </Text>
  </Wrapper>
);

export default MediaItem;
